import {
  ContentCompact,
  EmptyState,
  PaymentPendingIllustration,
  Section,
  TitleAndDescription,
  useOriginUrl,
} from '@angeplus/prever-component-lib';
import { HeaderHome } from 'components/headers/HeaderNotification';
import useCurrentAccountContracts from 'contract/useCurrentAccountContracts';
import { useWhatsappApi } from 'utils/useWhatsappApi';

const buildBillsUrl = (
  baseUrl: string,
  contracts: ReturnType<typeof useCurrentAccountContracts>['data'],
) => {
  const contractsUrl = `${baseUrl}/contracts`;
  const [contract] = contracts;

  if (!contract) {
    return contractsUrl;
  }

  if (
    contracts.every(({ contract_provider }) => contract_provider === 'gsadmin')
  ) {
    return `${baseUrl}/contracts-legacy/${contract.seqControl}/payment-options`;
  }

  if (contracts.length === 1 && contract.contract_provider === 'angeplus') {
    return `${contractsUrl}/contract/${contract.uuid}/payment-options`;
  }

  return contractsUrl;
};

export const OverdueBenefitUsage = () => {
  const baseUrl = useOriginUrl();
  const query = useCurrentAccountContracts();

  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+558000066688',
    text: 'Olá, eu gostaria de informações sobre as mensalidades em atraso.',
  });

  const billsUrl = buildBillsUrl(baseUrl, query?.data ?? []);

  return (
    <ContentCompact>
      <HeaderHome />
      <Section>
        <TitleAndDescription
          title="Mensalidades em atraso"
          description="Para acessar a Teleconsulta Veterinária e outros benefícios, você precisa regularizar o seu plano."
        />

        <EmptyState
          description="O pagamento é rápido e o benefício é liberado assim que ele for processado."
          illustration={<PaymentPendingIllustration />}
          buttonLabelPrimary="Pagar mensalidades"
          onClickButtonPrimary={() => window.location.replace(billsUrl)}
          buttonLabelSecondary="Entrar em contato pelo Whatsapp"
          onClickButtonSecondary={handleSendWhatsappMessage}
        />
      </Section>
    </ContentCompact>
  );
};
